import axios from 'axios';
import { DocumentsQuery } from '../graphql/dealboard.queries';
import { convertDealsReponse } from '@/dealboard/helpers/deal.helper';
import { IDeal } from '@/dealboard/types/deal';
import { apolloClient } from '@/apollo';
import { IDealDocument } from '@/dealboard/types/deal-document';
import { EFetchPolicy } from '@/api/types/enums/fetch-policy';

export class DealboardService {
  static async loadDeals(
    filter: string,
    showTeam: boolean,
    showAll: boolean,
    scope: string[],
    sortBy?: string,
    sortOrder?: string,
    limit?: number,
    offset?: number
  ): Promise<{ totalValue: number; deals: IDeal[] }> {
    const body: FormData = new FormData();
    body.append('filter', filter);
    body.append('team', showTeam.toString());
    body.append('showall', showAll.toString());
    body.append('sortby', sortBy || '');
    body.append('sortorder', sortOrder || '');
    if (limit !== undefined) {
      body.append('limit', `${limit}` || '10');
      body.append('offset', `${offset}` || '0');
    }
    scope.forEach(id => {
      body.append('scope[]', id);
    });

    const {
      data: { total_value, deals },
    } = await axios.post('/get/board/list', body);
    return {
      totalValue: total_value,
      deals: convertDealsReponse(deals),
    };
  }
  static async toggleReminders(payload: { documentId: string; value: boolean }): Promise<number> {
    const data = new FormData();
    data.append('action', 'accelerator');
    data.append('document-id', payload.documentId);
    data.append('type', 'reminders');
    data.append('value', payload.value.toString());
    const {
      data: { status },
    } = await axios.post('save/board', data);
    return status;
  }

  static async loadDealScore(ids: string[]): Promise<IDealDocument[]> {
    const {
      data: { documentList },
    } = await apolloClient.query({
      query: DocumentsQuery,
      variables: { ids },
      fetchPolicy: EFetchPolicy.CacheFirst,
    });
    return documentList;
  }
}
